// eslint-disable-next-line react-hooks/exhaustive-deps
import { ReactComponent as Reorder } from "assets/Reorder.svg";
import { setInnCode } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import DateRangePickerCalendar from "components/common/DateRangePickerCalendar";
import ButtonLink from "components/common/Link";
import Typography from "components/common/Typography";
import InncodeDropDown from "components/common/dropdowns/InncodeDropDown";
import { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { accessTypes } from "utils/CommonConstants";
import { getUserNameWithConditionalCheck } from "utils/SharedUtils";
import MyDashboard from "../MyDashboard";
import "./HotelUserDashbaordWrapper.scss";
import {
  fetchExternalUserDetailsAsync,
  reset,
  setCreatedDate,
  setOpenReorderSection
} from "./HotelUserDashboard.slice";
import { getHotelUserDashboardInncode } from "./HotelUserDashboardHelper";

const HotelUserDashboardWrapper: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const innCode = getHotelUserDashboardInncode();
  const formatDate = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const [searchParams, setSearchParams] = useSearchParams();
  const externalHltId = searchParams.get("member");
  const { userDetails, innCodeDetails } = useAppSelector((state) => state.hotelUserDashboardSlice.externalUser);
  const dateRangeFilter = useAppSelector((state) => state.hotelUserDashboardSlice.dateRangeFilter);
  const { isAbovePropertyUser, isCorp, isLeadership } = useAppSelector((state) => state.app.loggedInUserDetails);

  useEffect(() => {
    if (externalHltId) {
      dispatch(fetchExternalUserDetailsAsync({ hltIds: externalHltId }));
    }
  }, [externalHltId]);

  const handleOnChange = (value: string) => {
    if (isCorp || isAbovePropertyUser) {
      dispatch(setInnCode(value));
      setSearchParams({ member: externalHltId ?? "", inncode: value });
    } else {
      dispatch(setInnCode(value));
      localStorage.setItem("innCode", value);
    }
    dispatch(reset());
  };

  return (
    <div className={`hoteluser-dashboard-wrapper  ${externalHltId || !isLeadership ? "externalHltId" : ""} `}>
      {(isCorp || isAbovePropertyUser) && (
        <>
          <InncodeDropDown
            labelChildren={
              <Typography variant="body2" color={tokens.Text.General.Secondary}>
                Inncode Selected
              </Typography>
            }
            backgroundColor={tokens.Background.General.Color}
            parentBoxWidth={isMobileScreen ? "100%" : "250px"}
            width={isMobileScreen ? "170px" : "250px"}
            color={tokens.Text.General.Color}
            isCorp={isCorp || isAbovePropertyUser}
            value={innCode}
            onChange={handleOnChange}
            externalOptions={innCodeDetails}
            hideSearch
          />
          <Typography variant="h4" showBold color={tokens.Text.General.PrimaryBody}>
            {getUserNameWithConditionalCheck(userDetails?.displayName, userDetails?.firstName, userDetails?.lastName)}
          </Typography>
        </>
      )}
      {!isAbovePropertyUser && (
        <>
          <div className="edit-dashboard-container">
            <Button
              variant="text"
              label="Edit Dashboard"
              onClick={() => dispatch(setOpenReorderSection(true))}
              endIcon={<Reorder />}
              accessType={accessTypes.delete}
              className="edit-dashboard-btn"
            />
            <div>
              <div className="filter-box">
                <Typography color={tokens.Text.General.Secondary} variant={"body2"}>
                  Filter by
                </Typography>
                <div className="calendar-wrapper">
                  <DateRangePickerCalendar
                    dateRangeValue={{
                      startDate: dateRangeFilter?.createdDateFrom ? new Date(dateRangeFilter?.createdDateFrom) : null,
                      endDate: dateRangeFilter?.createdDateTo ? new Date(dateRangeFilter?.createdDateTo) : null
                    }}
                    onChange={(range: any) => {
                      dispatch(
                        setCreatedDate({
                          createdDateFrom: formatDate(range.startDate),
                          createdDateTo: formatDate(range.endDate)
                        })
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {dateRangeFilter?.createdDateFrom && (
            <div className="clear-filter">
              <ButtonLink
                text="Clear filter"
                sx={{ color: tokens.Text.General.Color }}
                textVariant="body2"
                underline="none"
                onClick={() => {
                  dispatch(
                    setCreatedDate({
                      createdDateFrom: null,
                      createdDateTo: null
                    })
                  );
                }}
              />
            </div>
          )}
        </>
      )}
      <MyDashboard />
    </div>
  );
};

export default HotelUserDashboardWrapper;
